import React from 'react'
import { Route } from 'react-router-dom'

import WaitFor from './WaitFor'

//If we render for this path lazy import a component, using WaitFor, and render it
function LazyRoute({ path, component, exact = false, store }) {
  //To add additional props to the route, testing specifically for we may want an exact lazy route

  const addProps = exact ? { exact: true } : {}

  return (
    <Route path={path} store={store} {...addProps}>
      <WaitFor action={component}>
        {resolution => {
          const Component = resolution.result?.default

          return <Component store={store} />
        }}
      </WaitFor>
    </Route>
  )
}

LazyRoute.propTypes = {}
LazyRoute.defaultProps = {}

export default LazyRoute
